<template>

<div v-if="!loading">
    <div class="card-body card-body--cta">
        <a :href="`dashboard/consultations?consultationStatus[]=incomplete`" class="card-info--cta"><i class="fa fa-search"></i> View Incomplete Consultations</a>
    </div>
    <div class="card" v-if="canSeeAllConsultations">
        <header class="card-header">
            <span class="card-header--title">
                Patient Consultations
            </span>
        </header>
        <div class="card-body" v-for="(consultation, key) in consultations">
            <div class="card--two-columns items-center">
                <div class="card-column card-column--vertical">
                    <span class="card-body--subtitle-dark">{{ consultation.dateCreated}}</span>
                    <span class="card-body--title card-body--title-dark">{{ consultation.title }}</span>
                    <div class="card-body--label">
                        <strong>Patient:</strong>
                        <span>{{ consultation.firstName }} {{ consultation.lastName }}</span>
                    </div>
                    <div :class="`card-body--label-${consultation.status}`">
                        {{ consultation.status }}
                    </div>
                </div>
                <div class="card-column">
                    <div class="card-action">
                        <a :href="'dashboard/consultations/' + consultation.id" class="button button-primary--small button-block">Review Consult</a>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="consultations.length <= 0" class="card-body card-body--messages">
            You do not currently have any new consultations to review.
        </div>
    </div>
    <div class="card" v-else>
        <header class="card-header">
            <span class="card-header--title">
                Patient Consultations
            </span>
        </header>
        <div class="card-body" v-for="(consultation, key) in consultations">
            <div class="card--two-columns items-center">
                <div class="card-column card-column--vertical">
                    <span class="card-body--subtitle-dark">{{ consultation.dateCreated}}</span>
                    <span class="card-body--title card-body--title-dark">{{ consultation.title }}</span>
                    <div class="card-body--label">
                        <strong>Patient:</strong>
                        <span>{{ consultation.firstName }} {{ consultation.lastName }}</span>
                    </div>
                    <div :class="`card-body--label-${consultation.status}`">
                        {{ consultation.status }}
                    </div>
                </div>
                <div class="card-column">
                    <div class="card-action">
                        <a :href="consultation.review" class="button button-primary--small button-block">Review Consult</a>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="consultations.length >= 0" class="card-body card-body--messages">
            You do not currently have any new consultations to review.
        </div>
    </div>
</div>
<div v-else class="lds-grid">
    <div class="lds-ripple"><div></div><div></div></div>
    <p>Loading incomplete consultations</p>
</div>
</template>

<script>
import axios from 'axios';
import { EventBus } from './event-bus';
export default {
    name: 'v-patient-consultations',
    props: ['canSeeAllConsultations'],
    data: function() {
        return {
            consultations: [],
            pagination: null,
            lastRequest: 0,
            scrollY: 0,
            currentPage: 1,
            loading: true,
            selectedCategory: '' // To store selected product category
        }
    },
    mounted() {
        // Listen for product category selection events
        EventBus.$on('product-category-selected', category => {
            this.selectedCategory = category;
            this.loading = true;
            this.currentPage = 1;
            this.consultations = [];
            this.loadConsultations();
        });

        window.addEventListener("scroll", this.handleScroll);

        this.loadConsultations();
    },
    
    methods: {
        loadConsultations() {
            if(this.canSeeAllConsultations === "true"){
                axios
                    .post(`/dashboard/findSubmittedAndUnclosed`, {
                        page: 1,
                        category: this.selectedCategory
                    })
                    .then((response) => {
                        this.consultations = [...response.data.data];
                        this.pagination = response.data.pagination;
                        this.currentPage = this.currentPage+1;
                        this.loading = false;
                    });
            } else {
                axios
                    .post(`/dashboard/findSubmittedAndUnclosedForProvider`, {
                        category: this.selectedCategory
                    })
                    .then((response) => {
                        this.consultations = [...response.data.data];
                        this.pagination = response.data.pagination;
                        this.currentPage = this.currentPage+1;
                        this.loading = false;
                    });
            }
        },
        
        handleScroll() {
            this.scrollY = window.scrollY;
            if(this.canSeeAllConsultations === "true"){
                if(this.pagination){
                    if (this.scrollY >= this.lastRequest + 2000) {
                        if(this.currentPage <= this.pagination.totalPages){
                            axios
                                .post(`/dashboard/findSubmittedAndUnclosed`, {
                                    page: this.currentPage,
                                    category: this.selectedCategory
                                })
                                .then((response) => {
                                    const newData = response.data.data;
                                    if(newData.length > 0){
                                        this.consultations.push(...newData);
                                    }
                                    
                                    this.pagination = response.data.pagination;
                                    this.currentPage = this.currentPage+1;
                                });
                            this.lastRequest = this.scrollY;
                        }
                    }
                }
            }else{
                if(this.pagination){
                    if (this.scrollY >= this.lastRequest + 2000) {
                        if(this.currentPage <= this.pagination.totalPages){
                            axios
                                .post(`/dashboard/findSubmittedAndUnclosedForProvider`, {
                                    page: this.currentPage,
                                    category: this.selectedCategory
                                })
                                .then((response) => {
                                    const newData = response.data.data;
                                    if(newData.length > 0){
                                        this.consultations.push(...newData);
                                    }
                                    
                                    this.pagination = response.data.pagination;
                                    this.currentPage = this.currentPage+1;
                                });
                            this.lastRequest = this.scrollY;
                        }
                    }
                }
            }
        }
    }
}


</script>

<style scoped lang="css">

.lds-grid{
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    justify-content: center;
}

.lds-ripple,
.lds-ripple div {
  box-sizing: border-box;
}
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #243153;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 8px;
    height: 8px;
    opacity: 1;
  }
  100% {
    top: 0;
    left: 0;
    width: 80px;
    height: 80px;
    opacity: 0;
  }
}

.lds-grid p{
    color: #243153;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/PatientConsultations.vue